module.exports = __webpack_public_path__ + "static/media/beer_icon_orange.a08b506c.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/beer_icon_orange.png
// module id = 93
// module chunks = 0